import createModel from './lib/create_model';

export default createModel({
  modelName: 'SystemConfiguration',
  properties: {
    fbAppId: String,
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/system_configuration.js